/* The email sign-up. One script for every capture on the page (snippets/lf-signup.liquid).
   The Shopify customer form still does the real submit; this adds the Klaviyo subscription and
   the source event, fire-and-forget, so a slow network can never cost the sign-up.
   The age box is enforced by `required`; this only adds the message and keeps the two
   checkboxes independent (unticking the opt-in still lets the form through, it just does not
   subscribe). */
(function () {
  'use strict';
  if (window.__lfSignup) { window.__lfSignup.scan(); return; }
  function init(root) {
    if (root.__lfs) return; root.__lfs = true;
    var form = root.querySelector('.lf-signup__form'); if (!form) return;
    var email = form.querySelector('[data-lf-signup-email]'),
        age = form.querySelector('[data-lf-signup-age]'),
        optin = form.querySelector('[data-lf-signup-optin]'),
        under = root.querySelector('.lf-signup__under');
    if (!email || !age) return;
    /* the under-13 line is only loud once she tries without ticking */
    age.addEventListener('invalid', function () { root.classList.add('is-under'); });
    age.addEventListener('change', function () { if (age.checked) root.classList.remove('is-under'); });
    form.addEventListener('submit', function () {
      if (!age.checked || !email.value.trim()) return;           /* required blocks it anyway */
      var key = root.dataset.klaviyo, list = root.dataset.list, source = root.dataset.source || '';
      if (!key) return;
      var props = { signup_source: source, signup_date: new Date().toISOString().slice(0, 10), age_confirmed_13_plus: true };
      try {
        /* the event records every confirmed sign-up, opted in or not */
        fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(key), {
          method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({ data: { type: 'event', attributes: { metric: { data: { type: 'metric', attributes: { name: 'Signed Up' } } }, properties: props, profile: { data: { type: 'profile', attributes: { email: email.value.trim(), properties: props } } } } } })
        });
        /* the list only when she left the opt-in ticked */
        if (list && (!optin || optin.checked)) {
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
            method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: { email: email.value.trim(), properties: props } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
          });
        }
      } catch (e) {}
    });
  }
  /* ---- programme applications: the answers to Klaviyo, and the age rule where it applies ----
     The age gate is per section (settings.age_gate). Wholesale is a trade application from a
     shop, not a teenager, so it runs without one and the age box is simply absent: everything
     below has to work whether or not it is in the DOM. */
  function initApply(cfg) {
    if (cfg.__lfa) return; cfg.__lfa = true;
    var form = document.getElementById(cfg.dataset.form); if (!form) return;
    var age = form.querySelector('[data-lf-apply-age]'),
        optin = form.querySelector('[data-lf-apply-optin]'),
        email = form.querySelector('[name="contact[email]"]'),
        name = form.querySelector('[name="contact[name]"]');
    if (!email) return;
    if (age) {
      age.addEventListener('invalid', function () { form.classList.add('is-under'); });
      age.addEventListener('change', function () { if (age.checked) form.classList.remove('is-under'); });
    }
    form.addEventListener('submit', function () {
      if ((age && !age.checked) || !email.value.trim()) return;
      var key = cfg.dataset.klaviyo; if (!key) return;
      /* every answer, so an application is readable in Klaviyo and not only in an inbox */
      var props = { programme: cfg.dataset.programme || '', applied_at: new Date().toISOString().slice(0, 10) };
      if (age) props.age_confirmed_13_plus = true;
      Array.prototype.forEach.call(form.elements, function (el) {
        var m = /^contact\[(.+)\]$/.exec(el.name || ''); if (!m) return;
        var k = m[1]; if (k === 'email' || k === 'name' || k === 'programme') return;
        props[k] = el.type === 'checkbox' ? (el.checked ? 'yes' : 'no') : el.value;
      });
      var attrs = { email: email.value.trim(), properties: props };
      if (name && name.value.trim()) {
        var parts = name.value.trim().split(/\s+/);
        attrs.first_name = parts.shift(); if (parts.length) attrs.last_name = parts.join(' ');
      }
      try {
        fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(key), {
          method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({ data: { type: 'event', attributes: { metric: { data: { type: 'metric', attributes: { name: cfg.dataset.metric || 'Applied to Programme' } } }, properties: props, profile: { data: { type: 'profile', attributes: attrs } } } } })
        });
        if (cfg.dataset.list && (!optin || optin.checked)) {
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
            method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'programme-' + (cfg.dataset.programme || 'application'), profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: cfg.dataset.list } } } } })
          });
        }
        /* and, when the section names a proxy path, to the worker that writes a DRAFT
           stockist entry. keepalive, because the Shopify form navigates immediately after.
           It 404s silently until the app proxy exists, which costs the applicant nothing:
           the email and the Klaviyo profile have already gone. */
        if (cfg.dataset.proxy) {
          fetch(cfg.dataset.proxy, {
            method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(Object.assign({ name: name ? name.value.trim() : '', email: email.value.trim() }, props))
          }).catch(function () {});
        }
      } catch (e) {}
    });
  }
  function scan() {
    document.querySelectorAll('[data-lf-signup]').forEach(init);
    document.querySelectorAll('[data-lf-apply-klaviyo]').forEach(initApply);
  }
  window.__lfSignup = { scan: scan };
  scan();
})();